/**
 * User types for domiciliation permissions
 */
export const USER_TYPES = {
  CLIENTE: 'cliente'
};




// WEBPACK FOOTER //
// ./src/constants/permissions.js